import * as React from 'react';
import Select from '@mui/material/Select';
import { MenuItem } from '@mui/material';

import styles from './select.module.css';

export type SelectOption = {
  value: string,
  title: string,
};

type SelectUiProps = {
  id?: string,
  options: SelectOption[],
  value: string,
  disabled?: boolean,
  className?: string,
  labelText?: string,
  placeholder?: string,
  error?: string | boolean | undefined,
  onChange: (val: string) => void,
  onBlur?: () => void,
};

function SelectUi(props: SelectUiProps) {
  const {
    id,
    options,
    value,
    disabled,
    labelText,
    placeholder,
    className,
    error,
    onChange,
    onBlur,
  } = props;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab' || event.key === 'Enter' || event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === ' ') {
      event.stopPropagation();
    }
  };

  return (
    <div className={styles.layout}>
      <label htmlFor={id} className={styles.label}>{labelText}</label>
      <Select
        className={`${styles.select} ${className}`}
        value={value || ''}
        onChange={(event) => {
          onChange(event.target.value as string);
        }}
        onKeyDown={handleKeyDown}
        MenuProps={{
          className: styles.menu,
          transitionDuration: 0,
        }}
        disabled={disabled}
        displayEmpty
        renderValue={(selected) => {
          if (!selected && placeholder) {
            return <span className={styles.placeholder}>{placeholder}</span>;
          }
          const selectedOption = options.find(option => option.value === selected);
          return selectedOption ? selectedOption.title : selected;
        }}
        onBlur={onBlur}
      >
        {options.map((option) => (
          // @ts-ignore
          <MenuItem value={option.value} key={option.value} className={styles.option}>
            {option.title}
          </MenuItem>
        ))}
      </Select>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
}

SelectUi.defaultProps = {
  disabled: false,
  className: '',
  placeholder: '',
  error: false,
};

export default SelectUi;
